// src/helpers/auth-header.js

export function authHeader() {
    // Return authorization header with JWT token
    const token = localStorage.getItem('token');
    
    if (token) {
      return { 'Authorization': `Bearer ${token}` };
    } else {
      return {};
    }
  }